/**
 * §6.10 Growth & Scalability — 6 growth levers.
 */

import React from 'react'
import {
  CreditCard, Users, Rocket, PieChart, RefreshCw, Layers, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { GROWTH } from '../data'

const ICONS = { CreditCard, Users, Rocket, PieChart, RefreshCw, Layers, Sparkles }

export default function Growth() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow tone="green">Growth &amp; Scalability</Eyebrow>
          <SectionHeading align="center"
            title={<>Built to grow{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">with your business.</span></>}
            subtitle="Six levers turn a white-label licence into a compounding SaaS business — recurring revenue, expansion, analytics and continuous platform improvement."
          />
        </div>
        <FeatureGrid items={GROWTH} icons={ICONS} cols={3} />
      </Container>
    </section>
  )
}
